import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ContentFeed, ContentFeedSource} from '../../../contentFeeds.types';
import {CreativeTemplate} from 'common/src/modules/creativeTemplates/creativeTemplates.types';

interface ContentFeedPageBaseState {
  isLoading: boolean;
  feed: ContentFeed | null;
  referenceTemplate: CreativeTemplate | null;
}

const contentFeedPageBaseInitialState: ContentFeedPageBaseState = {
  isLoading: false,
  feed: null,
  referenceTemplate: null,
};

const contentFeedPageBaseSlice = createSlice({
  name: 'contentFeedPageBase',
  initialState: contentFeedPageBaseInitialState,
  reducers: {
    resetContentFeedPage: () => contentFeedPageBaseInitialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFeed: (state, action: PayloadAction<ContentFeed>) => {
      state.feed = action.payload;
    },
    setFeedName: (state, action: PayloadAction<string>) => {
      if (state.feed) {
        state.feed.name = action.payload;
      }
    },
    setFeedSource(state, action: PayloadAction<ContentFeedSource>) {
      if (state.feed) {
        state.feed.feedSource = action.payload;
      }
    },
    clearFeed: (state) => {
      state.feed = null;
    },
    setReferenceTemplate: (state, action: PayloadAction<CreativeTemplate | null>) => {
      state.referenceTemplate = action.payload;
    },
  },
});

export const {resetContentFeedPage, setIsLoading, setFeed, setFeedName, setFeedSource, clearFeed, setReferenceTemplate} =
  contentFeedPageBaseSlice.actions;

export default contentFeedPageBaseSlice.reducer;
